module.exports = __webpack_public_path__ + "img/LACOMER_MOBILE.bf4d549c.png";